import { createStore, getDefaultStore } from 'jotai/vanilla';
import { getContext, setContext } from 'svelte';

import type { TeoCore } from '@/teoCore/TeoCore';

import { TeoCore$ } from '../teo-context';

// Keep only one store around, so we share it between providers (because of webcomponents)
const jotaiStores = new WeakMap<TeoCore, JotaiStore>();

export function getOrCreateTeoJotaiStore(teoCore: TeoCore) {
  const existingStore = jotaiStores.get(teoCore);
  if (existingStore) {
    return existingStore;
  }
  const newStore = createStore();
  newStore.set(TeoCore$, teoCore);
  jotaiStores.set(teoCore, newStore);
  return newStore;
}
export type JotaiStore = ReturnType<typeof createStore>;

export interface UseStoreOptions {
  store: JotaiStore;
}

export function setJotaiStoreContext(store: JotaiStore) {
  setContext('jotaiStore', store);
}

export function setupJotaiStoreContext(teoCore: TeoCore) {
  setJotaiStoreContext(getOrCreateTeoJotaiStore(teoCore));
}

export function getJotaiStoreContext(): Maybe<JotaiStore> {
  return getContext('jotaiStore');
}

export function useStore(options?: UseStoreOptions) {
  if (options?.store) {
    return options.store;
  }
  try {
    const ctxStore = getJotaiStoreContext();
    if (ctxStore) {
      return ctxStore;
    }
  } catch {
    // ignore
  }
  return getDefaultStore();
}
